import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";
import { Container, Row, Col, Button, Stack } from "react-bootstrap";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import moment from "moment";
import { toast } from "react-toastify";

import { useAuthContext } from "../../contexts/AuthContext";
import BatchReportService from "../../services/batchReport.service";
import ProcessLogService from "../../services/processLog.service";
import ProcessLogs from "./ProcessLogs";
import FormSelect from "../../components/FormField/FormSelect";
import { yearList, monthList, batchOptions } from "../../constant/index";
import ProcessFileService from "../../services/processFile.service";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "./BatchReport.scss";

const ToDayDate = new Date();
const currentyear = ToDayDate.getUTCFullYear();
const PageSizeOptions = [10, 100, 500, 1000];
const NoOfTabs = 5;

function BatchReport() {
  let { projectId } = useParams();

  const agGridRef = useRef(new Array(NoOfTabs));

  const navigate = useNavigate();
  const { user, setIsLoading } = useAuthContext();

  const [batchReports, set_batchReports] = useState([]);
  const [batchLogs, setBatchLogs] = useState([]);
  const [pageSize, setPageSize] = useState(
    Array(NoOfTabs).fill(PageSizeOptions[0])
  );
  const [selectedBatch, set_selectedBatch] = useState({});
  const [selectedYear, setSelectedYear] = useState(currentyear);
  const [selectedMonth, setSelectedMonth] = useState();
  const [batchOption, setBatchOption] = useState();
  /* Tab Panel */
  const [selectedTab, set_selectedTab] = useState("all");
  const [filteredBReport, set_filteredBReport] = useState([]);
  const [downloadedReport, set_downloadedReport] = useState([]);
  const [validationReport, set_validationReport] = useState([]);
  const [completeReport, set_completeReport] = useState([]);
  const [failedReport, set_failedReport] = useState([]);
  const [uploadReport, set_uploadReport] = useState([]);

  useEffect(() => {
    if (user) {
      retrieveBatchReports();
    }
  }, [user, projectId]);

  useEffect(() => {
    if (batchReports.length) categoriseBatchReport(batchReports);
  }, [batchReports]);

  useEffect(() => {
    if (selectedBatch && selectedBatch._id) {
      fetchLogsByBatch(selectedBatch._id);
    } else setBatchLogs([]);
  }, [selectedBatch]);

  function retrieveBatchReports() {
    setIsLoading(true);
    BatchReportService.getByProject(projectId).then((response) => {
      setIsLoading(false);
      set_batchReports([...response.data.data]);
    });
  }

  function categoriseBatchReport(repoData) {
    const filteredBReport = repoData,
      downloadedReport = [],
      validationReport = [],
      completeReport = [],
      failedReport = [],
      uploadReport = [];

    for (let i = 0; i < repoData.length; i++) {
      const repoitem = repoData[i];
      switch (repoitem.step) {
        case "downloaded":
          downloadedReport.push(repoitem);
          break;
        case "validation":
        case "File Process":
          validationReport.push(repoitem);
          break;
        case "process":
        case "complete":
        case "cancelled":
          completeReport.push(repoitem);
          break;
        case "failed":
          failedReport.push(repoitem);
          break;
        case "upload":
          uploadReport.push(repoitem);
          break;
        default:
          console.info("Default case in categorise report!");
      }
    }
    set_filteredBReport(filteredBReport);
    set_downloadedReport(downloadedReport);
    set_validationReport(validationReport);
    set_completeReport(completeReport);
    set_failedReport(failedReport);
    set_uploadReport(uploadReport);
  }

  function pageSizeChanged(e, tbInx) {
    let pgValue = e.target.value;
    setPageSize(
      pageSize.map((pgtm, pgix) => (pgix === tbInx ? pgValue : pgtm))
    );
    agGridRef.current[tbInx].api.paginationSetPageSize(Number(pgValue));
  }

  function fetchLogsByBatch(batchid) {
    setIsLoading(true);
    ProcessLogService.getByBatch(batchid).then((response) => {
      setIsLoading(false);
      const batch_logs =
        response.data && response.data.data && response.data.data.length
          ? response.data.data
          : [];
      setBatchLogs(batch_logs);
    });
  }

  function batchSelected(e) {
    set_selectedBatch(e.data);
  }

  function batchActionSelected(value, item) {
    setBatchOption(value);
    if (value === "process" || value === "reprocess") {
      processFileById(item._id);
    } else if (value === "cancel") {
      cancelProcessFile(item._id);
    } else if (value === "delete") {
      deleteFileById(item._id);
    } else if (value === "upload" || value === "reupload") {
      uploadFileById(item._id);
    }
  }

  /* Tab Panel */
  function tabSelected(tabKey) {
    set_selectedTab(tabKey);
    resetLogByActiveTab(tabKey);
  }

  function resetLogByActiveTab(currentTab) {
    let tabInx = 0;
    const currentList =
      currentTab === "downloaded"
        ? ((tabInx = 1), downloadedReport)
        : currentTab === "validation"
        ? ((tabInx = 2), validationReport)
        : currentTab === "complete"
        ? ((tabInx = 3), completeReport)
        : currentTab === "failed"
        ? ((tabInx = 4), failedReport)
        : currentTab === "upload"
        ? ((tabInx = 5), uploadReport)
        : filteredBReport;

    if (currentList.length) {
      set_selectedBatch(currentList[0]);
      agGridRef.current[tabInx].api.forEachNode(function (node, index) {
        // console.log("node.data", node.data);
        if (index === 0) node.setSelected(true);
      });
    } else set_selectedBatch({});
  }

  function downloadFile() {
    const payload = {
      year: selectedYear,
      month: selectedMonth,
      projectId: projectId,
    };
    ProcessFileService.download(payload).then((response) => {});
  }

  function processFile() {
    const payload = {
      year: selectedYear,
      month: selectedMonth,
      projectId: projectId,
    };
    ProcessFileService.process(payload).then((response) => {});
  }

  function processFileById(id) {
    ProcessFileService.processById(id).then((response) => {});
  }

  function uploadFiles() {
    const payload = {
      year: selectedYear,
      month: selectedMonth,
      projectId: projectId,
    };
    ProcessFileService.uploadFiles(payload).then((response) => {});
  }

  function uploadFileById(id) {
    ProcessFileService.uploadFileById(id).then((response) => {});
  }

  function deleteFileById(id) {
    ProcessFileService.deleteFileById(id).then((response) => {});
  }

  function cancelProcessFile(id) {
    ProcessFileService.cancelFileById(id).then((response) => {});
  }

  const columnDefs = [
    {
      headerName: "Suppliper Code",
      field: "supplierCode",
      width: "150",
    },
    {
      headerName: "Batch",
      field: "_id",
      width: "200",
    },
    {
      headerName: "File Name",
      field: "fileName",
      width: "250",
    },
    {
      headerName: "Year-Month",
      field: "year",
      width: "120",
      cellRendererFramework: (data) => `${data.data.year} - ${data.data.month}`,
    },
    {
      headerName: "Step",
      field: "step",
      width: "150",
    },
    {
      headerName: "Status Text",
      field: "statustxt",
      width: "150",
    },
    {
      headerName: "Transaction Count",
      field: "transactionCount",
      width: "150",
    },
    {
      headerName: "Modified By",
      field: "modifiedBy.name",
      width: "120",
      cellRendererFramework: (data) => (!data.value ? "admin" : data.value),
    },
    {
      headerName: "Updated At",
      field: "updatedAt",
      width: "160",
      cellRendererFramework: (data) =>
        moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A"),
    },
    {
      headerName: "Action",
      field: "id",
      filter: false,
      sortable: false,
      width: "150",
      cellRendererFramework: (data) => (
        <Row key={data.value}>
          <Col>
            <FormSelect
              className="forminput"
              placeholder="Select Options"
              optionList={batchOptions}
              value={batchOption}
              item={data.data}
              setFunc={batchActionSelected}
              showLabel={false}
            />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}>
          <h1 className="mt-4 pageTitle">Batch Report</h1>
        </Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            {/* <Button variant="primary" className="mt-4" onClick={() => navigate(`/project/${projectId}/supplier/create`)}><FcPlus /> Create Supplier</Button> */}
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row className="mb-4">
        <Col md="12" className="">
          <Row>
            <Col md="3" className="flx-dir-col">
              <label className="mb-0">Select Year</label>
              <FormSelect
                className="forminput"
                placeholder="Select Year"
                optionList={yearList}
                value={selectedYear}
                setFunc={setSelectedYear}
                showLabel={false}
              />
            </Col>
            <Col md="3" className="flx-dir-col">
              <label className="mb-0">Select Month</label>
              <FormSelect
                className="forminput"
                placeholder="Select Month"
                optionList={monthList}
                value={selectedMonth}
                setFunc={setSelectedMonth}
                showLabel={false}
              />
            </Col>
            <Col md="auto" className="d-flex">
              <button
                className="btn btn-primary mt-auto mb-3"
                disabled={!selectedMonth}
                onClick={downloadFile}
              >
                Download File
              </button>
            </Col>
            <Col md="auto" className="d-flex">
              <button
                className="btn btn-primary mt-auto  mb-3"
                disabled={!selectedMonth}
                onClick={processFile}
              >
                Process File
              </button>
            </Col>
            {/* <Col md="auto" className="d-flex">
              {/* <button
                className="btn btn-primary mt-auto  mb-3"
                disabled={!selectedMonth}
                onClick={uploadFiles}
              >
                Upload File
              </button> 
            </Col> */}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col>
          <Tab.Container
            id="tab-panel-batch-report"
            activeKey={selectedTab}
            onSelect={tabSelected}
          >
            <Row className="mt-3">
              <Col md={12} className="nav-theme-1">
                <Nav variant="tabs">
                  <Nav.Item className="clr-thm-all">
                    <Nav.Link eventKey="all">
                      ALL ({filteredBReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="clr-thm-downloaded">
                    <Nav.Link eventKey="downloaded">
                      DOWNLOADED ({downloadedReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="clr-thm-validation">
                    <Nav.Link eventKey="validation">
                      VALIDATION ({validationReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="clr-thm-complete">
                    <Nav.Link eventKey="complete">
                      PROCESSED ({completeReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="clr-thm-failed">
                    <Nav.Link eventKey="failed">
                      FAILED ({failedReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="clr-thm-upload">
                    <Nav.Link eventKey="upload">
                      UPLOAD ({uploadReport.length || 0})
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col md={12}>
                <Tab.Content className="tab-theme-1">
                  <Tab.Pane eventKey="all" className="tab-pane-all">
                    <GridTable
                      grdTblIndex={0}
                      showGrid={filteredBReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[0] = elmref)}
                      gridColDef={columnDefs}
                      gridData={filteredBReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[0]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="downloaded"
                    className="tab-pane-downloaded"
                  >
                    <GridTable
                      grdTblIndex={1}
                      showGrid={downloadedReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[1] = elmref)}
                      gridColDef={columnDefs}
                      gridData={downloadedReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[1]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="validation"
                    className="tab-pane-validation"
                  >
                    <GridTable
                      grdTblIndex={2}
                      showGrid={validationReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[2] = elmref)}
                      gridColDef={columnDefs}
                      gridData={validationReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[2]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="complete" className="tab-pane-complete">
                    <GridTable
                      grdTblIndex={3}
                      showGrid={completeReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[3] = elmref)}
                      gridColDef={columnDefs}
                      gridData={completeReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[3]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="failed" className="tab-pane-failed">
                    <GridTable
                      grdTblIndex={4}
                      showGrid={failedReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[4] = elmref)}
                      gridColDef={columnDefs}
                      gridData={failedReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[4]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="upload" className="tab-pane-upload">
                    <GridTable
                      grdTblIndex={5}
                      showGrid={uploadReport.length && projectId}
                      gridTblRef={(elmref) => (agGridRef.current[5] = elmref)}
                      gridColDef={columnDefs}
                      gridData={uploadReport}
                      batchSelected={batchSelected}
                      gtPageSize={pageSize[5]}
                      pageSizeChanged={pageSizeChanged}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Col>
      </Row>

      <Row>
        <Col>
          <ProcessLogs
            batchCode={selectedBatch && selectedBatch._id}
            processLogs={batchLogs}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default BatchReport;

const GridTable = ({
  grdTblIndex = 0,
  showGrid = false,
  gridTblRef = void 0,
  gridColDef,
  gridData = [],
  batchSelected,
  gtPageSize,
  pageSizeChanged,
}) => {
  const defaultColDef = useMemo(
    () => ({
      filter: true,
      sortable: true,
      // flex: 1,
      // minWidth: 150,
    }),
    []
  );

  const getRowClass = (params) => {
    switch (params.data.step) {
      case "downloaded":
        return "gtrow-downloaded";
      case "validation":
      case "File Process":
        return "gtrow-validation";
      case "process":
      case "complete":
      case "cancelled":
      case "upload":
        return "gtrow-complete";
      case "failed":
        return "gtrow-failed";
      // case "upload":
      //   return "gtrow-upload";
      default:
        console.info("Default case in Ag Grid Row classes...");
    }
  };

  return (
    <div
      className="ag-theme-balham theme-01"
      style={{ height: "360px", width: "100%" }}
    >
      {showGrid ? (
        <>
          <div className="pagination-wrap">
            <span>Page Size: </span>
            <select
              onChange={(e) => pageSizeChanged(e, grdTblIndex)}
              value={gtPageSize}
            >
              {PageSizeOptions.map((pitm, pinx) => (
                <option key={pitm} value={pitm}>
                  {pitm}
                </option>
              ))}
            </select>
          </div>
          <AgGridReact
            ref={(el) => gridTblRef && gridTblRef(el)}
            pagination={true}
            rowHeight={50}
            defaultColDef={defaultColDef}
            columnDefs={gridColDef}
            rowData={gridData}
            paginationPageSize={gtPageSize}
            rowSelection={"single"}
            onRowClicked={(e) => batchSelected(e)}
            getRowClass={getRowClass}
          ></AgGridReact>
        </>
      ) : (
        <div className="no-data-msg">No Batch Report Found</div>
      )}
    </div>
  );
};
